import { RouteRecordRaw } from 'vue-router';
import { requireAuth } from '@/common/router/navigationGuard';
import { VIEW_MODE } from '@/common/define/common.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { BASE_MENU_VALUE } from '@/common/components/organisms/baseMenu/baseMenu.define';
import { requireDomainTargetOrTutorial, requireInstances } from '@/common/router/authGuard';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const NAME_PREFIX = 'clickhouse_';

const clickhouseMenu: RouteRecordRaw[] = [
  {
    path: '/clickhouse/',
    name: `${NAME_PREFIX}SQL Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'topNAnalysis',
        name: `${NAME_PREFIX}Top N Analysis`,
        component: () => import('@/database/views/topNAnalysis/clickhouse/TopNAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
      {
        path: 'searchSql',
        name: `${NAME_PREFIX}Search SQL`,
        component: () => import('@/database/views/searchSql/clickhouse/SearchSql.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_CLICKHOUSE_PA,
        [VIEW_MODE.MAXGAUGE]:
          ROLE_PERMISSION_KEY.MONITORING.MONITORING_CLICKHOUSE_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
  {
    path: '/clickhouse/',
    name: `${NAME_PREFIX}Performance Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'trendAnalysis',
        name: `${NAME_PREFIX}Trend Analysis`,
        component: () => import('@/database/views/trendAnalysis/clickhouse/TrendAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_CLICKHOUSE_PA,
        [VIEW_MODE.MAXGAUGE]:
          ROLE_PERMISSION_KEY.MONITORING.MONITORING_CLICKHOUSE_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
];

const subMenuMap = {
  instanceView: `${NAME_PREFIX}Real Time Monitoring`,
  sqlAnalysis: `${NAME_PREFIX}SQL Analysis`,
  performanceAnalysis: `${NAME_PREFIX}Performance Analysis`,
};

const getClickhouseNaviMenu = (subMenu?: string) => {
  const filteredMenu = extractAccessibleRoutes(clickhouseMenu);

  if (subMenu && subMenuMap[subMenu]) {
    return filteredMenu.filter((menu) => menu.name === subMenuMap[subMenu]);
  }

  return filteredMenu;
};

export { clickhouseMenu, getClickhouseNaviMenu, NAME_PREFIX };
